// removed by extract-text-webpack-plugin
module.exports = {"errorRed":"#DC001C","container":"container-QjDN2","alternateLink":"alternateLink-S1lsN alternateLink-1Ug6E","hr":"hr-1NGCP hr-FrSAw","leftAlign":"leftAlign-2xFrh leftAlign-1wyXx","or":"or-wsdSE or-2DU3i","orText":"orText-2W8Y2 orText-FTmEP","button":"button-2cQdv button-97MMb","forgot":"forgot-2TRHk","loader":"loader-462q2","error":"error-3DS0E","userErrorMessage":"userErrorMessage-9g8sj","userError":"userError-1ltq2","userErrorDescription":"userErrorDescription-3iMOS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/login/_login.css
// module id = 533
// module chunks = 1